import { useState, useEffect } from 'react';
import { isChromeBrowser } from '~/utils/agent';

type ChromeExtensionAttributes = {
  version: string;
  installed: boolean;
  checking: boolean;
};

const useChromeExtension = () => {
  const [attributes, setAttributes] = useState<ChromeExtensionAttributes>({
    version: '',
    installed: false,
    checking: true,
  });

  useEffect(() => {
    if (
      !isChromeBrowser() ||
      !chrome ||
      typeof chrome.runtime === 'undefined'
    ) {
      setAttributes({ ...attributes, checking: false });
      return;
    }

    chrome.runtime?.sendMessage(
      process.env.CHROME_EXTENSION_ID as string,
      'version',
      (response) => {
        if (response) setAttributes({ ...response, checking: false });
        else setAttributes({ ...attributes, checking: false });
      }
    );
  }, []);

  return attributes;
};

export default useChromeExtension;
